import React from "react"
import { Button, KIND } from "baseui/button"
import { ChevronLeft, ChevronRight } from "baseui/icon"
import SliderComponent from "react-slick"

const Slick = ({ children, settings }: any) => {
  const Arrow = ({ icon, direction, onClick }: any) => {
    return (
      <Button
        $style={{
          position: "absolute",
          top: "28%",
          zIndex: 100,
          ...(direction === "right" ? { right: "5px" } : { left: "5px" }),
        }}
        kind={KIND.minimal}
        onClick={onClick}
      >
        {icon}
      </Button>
    )
  }

  const defaultSettings = {
    dots: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 4,
    slidesToScroll: 2,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    nextArrow: (
      <Arrow
        icon={
          <ChevronRight
            size={35}
            color={"white"}
            overrides={{ Svg: { style: { cursor: "pointer" } } }}
          />
        }
        direction={"right"}
      />
    ),
    prevArrow: (
      <Arrow
        icon={
          <ChevronLeft
            size={35}
            color={"white"}
            overrides={{ Svg: { style: { cursor: "pointer" } } }}
          />
        }
        direction={"left"}
      />
    ),
  }
  return (
    <>
      <SliderComponent {...defaultSettings} {...settings}>
        {children}
      </SliderComponent>
    </>
  )
}

export default Slick
